import { render, staticRenderFns } from "./ActivitiesSkills.vue?vue&type=template&id=35be7a36&"
import script from "./ActivitiesSkills.vue?vue&type=script&lang=js&"
export * from "./ActivitiesSkills.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesSkills.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports